module.exports = __webpack_public_path__ + "static/media/login.8d543bb3.png";